<template>
    <section class="forms">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-md-6 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Update Profile</h4>

                        <form class="forms-sample">
                            <b-form-group label="Name" label-for="input5">
                                <b-form-input type="text"
                                              v-model="$v.form.Username.$model"
                                              :state="$v.form.Username.$dirty ? !$v.form.Username.$error : null"
                                              aria-describedby="input-1-live-feedback" id="input5"
                                              placeholder="Name"></b-form-input>
                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                            <b-form-group label="Email address" label-for="input6">
                                <b-form-input type="email" autocomplete="new-password"
                                              placeholder="Email"
                                              readonly
                                              v-model="form.email"
                                              aria-describedby="input-3-live-feedback"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                    id="input-group-2"
                                    label="Password"
                                    label-for="input-2"
                            >
                                          <span class="icon is-small is-right w-100"
                                                style="">
                                        <b-form-input
                                                id="input-2"
                                                autocomplete="new-password"
                                                :type="inputType"
                                                placeholder="Password"
                                                v-model="$v.form.password.$model"
                                                :state="$v.form.password.$dirty ? !$v.form.password.$error : null"
                                                aria-describedby="input-3-live-feedback"
                                        ></b-form-input>
                                         <b-form-invalid-feedback v-if="!$v.form.password.required"
                                                                  id="input-3-live-feedback">This is a required field.</b-form-invalid-feedback>
                                         <b-form-invalid-feedback v-if="!$v.form.password.minLength"
                                                                  id="input-3-live-feedback">Password must have at least {{$v.form.password.$params.minLength.min }} letters.</b-form-invalid-feedback>
                                         <b-form-invalid-feedback v-if="form.password !== '' && !$v.form.password.valid"
                                                                  id="input-3-live-feedback">Password contains atleast One Uppercase, One Lowercase, One Number and One Special Chacter.</b-form-invalid-feedback>
                                      <i @click="toggleShow" class="fas password-icon"
                                         :class="{'fa fa-eye': showPassword, 'fa fa-eye-slash': !showPassword, }"></i></span>

                            </b-form-group>
                            <b-form-group
                                    id="input-group-4"
                                    label="Confirm Password"
                                    label-for="input-4"
                            >
                                          <span class="icon is-small is-right w-100">
                                        <b-form-input
                                                id="input-4"
                                                autocomplete="new-password"
                                                :type="inputType1"
                                                placeholder="Confirm Password"
                                                v-model="$v.form.password_confirmation.$model"
                                                :state="$v.form.password_confirmation.$dirty ? !$v.form.password_confirmation.$error : null"
                                                aria-describedby="input-4-live-feedback"
                                        ></b-form-input>
                                              <b-form-invalid-feedback v-if="!$v.form.password_confirmation.required"
                                                                       id="input-3-live-feedback">This is a required field.</b-form-invalid-feedback>
                                         <b-form-invalid-feedback v-if="!$v.form.password_confirmation.sameAsPassword"
                                                                  id="input-4-live-feedback">Passwords must be identical.</b-form-invalid-feedback>
                                      <i @click="toggleConfirmShow" class="fas password-icon"
                                         :class="{'fa fa-eye': showPassword1, 'fa fa-eye-slash': !showPassword1, }"></i></span>

                            </b-form-group>

                            <b-form-group label="Upload file" label-for="input8">
                                <img :src="`${$server_url}images/profile/${Image}`" alt="" class="mb-1 img-fluid"> <br>
                                <b-form-file ref="fileInput" accept="image/png, image/jpeg, image/bmp" id="input8"
                                             placeholder="Choose a file..." @change="onFileSelected"></b-form-file>
                                <!-- <a href="javascript:void(0)" @click="removeImage">Remove Image</a> -->
                                <!--                                <input type="file" ref="fileInput" @change="onFileSelected">-->
                            </b-form-group>

                            <b-button type="button" variant="success" :disabled="isDisabled" @click="onSubmit()"
                                      class="mr-2">Submit
                            </b-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import Vue from "vue";
    import SortedTablePlugin from "vue-sorted-table";
    import API from '@/api'
    import Snotify, {SnotifyPosition} from 'vue-snotify'
    import {validationMixin} from "vuelidate";
    import {required, minLength, email, requiredIf, sameAs} from "vuelidate/lib/validators";

    const options = {
        toast: {
            position: SnotifyPosition.rightTop,
        }
    }
    Vue.use(Snotify, options)
    Vue.use(SortedTablePlugin, {
        ascIcon: '<i class="ti-arrow-down"></i>',
        descIcon: '<i class="ti-arrow-up"></i>'
    });
    export default {
        name: 'Users',
        mixins: [validationMixin],
        data() {
            return {
                form: {
                    Username: "",
                    email: "",
                    password: "",
                    password_confirmation: "",
                    UserID: "",
                    title: "",
                    mobile_phone: "",
                    Image: [],
                },
                isDisabled: false,
                showPassword: true,
                selectedFile: null,
                Image: null,
                showPassword1: true,
                inputType: 'password',
                inputType1: 'password',
            };
        },
        validations: {
            form: {
                Username: {
                    required,
                }, password: {
                    required: requiredIf((value) => value.password !== ''),
                    minLength: minLength(6),
                    valid: function (value) {
                        const containsUppercase = /[A-Z]/.test(value)
                        const containsLowercase = /[a-z]/.test(value)
                        const containsNumber = /[0-9]/.test(value)
                        const containsSpecial = /[#?!@$%^&*-]/.test(value)
                        return containsUppercase && containsLowercase && containsNumber && containsSpecial
                    },
                }, password_confirmation: {
                    sameAsPassword: sameAs('password')
                }

            }
        },
        methods: {
            getAuthUser() {
                this.$v.form.$reset();
                API.getAuthUser(
                    '', data => {
                        this.form.Username = data.Username;
                        this.form.UserID = data.UserID;
                        this.form.email = data.email;
                        this.form.mobile_phone = data.mobile_phone;
                        this.Image = data.Image;
                    },
                    err => {
                    }
                )
            },
            onSubmit() {
                this.$v.form.$touch();
                if (this.$v.form.$anyError) {
                    if (!this.$v.form.password.valid && this.$v.form.password !== '' && this.form.Username != '') {
                        this.isDisabled = true;
                        this.userForm();
                    } else {
                        return;
                    }
                }
                if (this.form.Username != '' && this.form.email != '') {
                    this.isDisabled = true;
                    this.userForm();
                } else {
                    this.$snotify.warning('Please fill required fields', {
                        timeout: 2000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                    });
                    this.isDisabled = false;
                }
            }, resetForm() {
                var self = this; //you need this because *this* will refer to Object.keys below`

                //Iterate through each object field, key is name of the object field`
                Object.keys(this.data.form).forEach(function (key, index) {
                    self.data.form[key] = '';
                });
            }, userForm() {

                const fd = new FormData();
                if (this.selectedFile != null ) {
                    fd.append('file', this.selectedFile, this.selectedFile.Username)
                }
                fd.append('data', JSON.stringify(this.form))

                API.updateUserProfile(
                    fd,
                    data => {
                        this.isDisabled = false;
                        this.$snotify.success(data.message, {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                        });
                        this.$v.form.$reset();

                    },
                    err => {
                        this.isDisabled = false;
                        this.$snotify.error(err['data']['errors']['email'][0], {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                        });

                    }
                )
            },
            toggleShow() {
                this.showPassword = !this.showPassword;
                if (this.showPassword) {
                    this.inputType = 'password';
                } else {
                    this.inputType = 'text';
                }
            }, toggleConfirmShow() {
                this.showPassword1 = !this.showPassword1;
                if (this.showPassword1) {
                    this.inputType1 = 'password';
                } else {
                    this.inputType1 = 'text';
                }
            }, onFileSelected(event) {
                this.selectedFile = event.target.files[0]
                this.form.Image = URL.createObjectURL(this.selectedFile)
            },
            // removeImage() {
            //     this.selectedFile = null;
            //     this.Image = '';
            // }
        }, computed: {
            rows() {
                return this.numberOfRoles;
            }
        },
        mounted() {

        }, beforeMount() {
            this.getAuthUser();
        }
    }
</script>
